// eslint-disable-next-line no-shadow
export enum UserActionTypes {
  SET_USER_PROFILE = "SET_USER_PROFILE",
  SAVE_USER_FILTER = "SAVE_USER_FILTER",
  SET_USER_FILTER = "SET_USER_FILTER",
}
